import { createSelector } from '@reduxjs/toolkit';

export const wnModalContentActiveBiochemicalPlan = createSelector(
  [state => state.wnModalContent.biochemicalPlan.active],
  biochemicalPlan => biochemicalPlan,
);
